import { render } from "./SenHeader.vue?vue&type=template&id=3184c79f"
import script from "./SenHeader.vue?vue&type=script&lang=js"
export * from "./SenHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__